module.exports = __webpack_public_path__ + "static/img/spring_tab2_selected.416a3fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/spring_tab2_selected.png
// module id = 359
// module chunks = 32